import React, { useMemo } from "react";

import { useProfile } from "app/context";
import { EndorsementLink, EventLink, ProfileLink, RecognitionLink } from "app/links";
import { t, Trans } from "app/utils";
import getBadgeTypes from "constants/getBadgeTypes";

import NotificationBody from "./NotificationBody";

const AutoRecognitionEntity = ({ recognition }) => (
  <>
    <Trans>Check out your</Trans>
    {" "}
    <RecognitionLink recognition={recognition}>
      <Trans>recognition</Trans>
    </RecognitionLink>
    .
  </>
);

const EventEntity = ({ event }) => (
  <>
    <Trans>Check out your</Trans>
    {" "}
    <EventLink event={event} />
    {" "}
    <Trans>event</Trans>.
  </>
);

const RecognitionEntity = ({ recognition }) => (
  <>
    <Trans>Check out your</Trans>
    {" "}
    <RecognitionLink recognition={recognition}>
      <Trans>recognition from {recognition.creator.name}</Trans>
    </RecognitionLink>
    .
  </>
);

const EndorsementEntity = ({ endorsement }) => (
  <Trans>
    Check out
    {" "}
    <EndorsementLink endorsement={endorsement}>the endorsement</EndorsementLink>
    {" "}
    from
    {" "}
    <ProfileLink user={endorsement.creator} />.
  </Trans>
);

const PointIncrementEntity = ({ source, entity }) => {
  switch (source) {
    case "auto_recognition":
      return <AutoRecognitionEntity recognition={entity} />;
    case "recognition":
      return <RecognitionEntity recognition={entity} />;
    case "event_with_two_new":
    case "host_coffee":
    case "host_lunch":
    case "host_social":
    case "host_wellness":
    case "host_charity":
    case "host_l_and_d":
    case "meet_other_department":
      return <EventEntity event={entity} />;
    case "receive_endorsement":
      return <EndorsementEntity endorsement={entity} />;
    default:
      return null;
  }
};

const PointIncrementNotification = ({ notification }) => {
  const { profile } = useProfile();
  const { entity } = notification;

  const badgeType = useMemo(
    () => getBadgeTypes(profile).find(({ key }) => key === entity.source),
    [entity, profile]
  );

  const bonusScore = badgeType => {
    if (entity.detail) {
      return t(`Awarded a community score bonus for: ${entity.detail}`);
    }

    return badgeType.past;
  };

  // In the case of "arbitrary"-type point increments, use a default badge
  const badge = badgeType ? badgeType.image : "cup";
  const message = badgeType ? bonusScore(badgeType) : t("Awarded a community score bonus by an admin.");

  return (
    <NotificationBody badge={badge} points={entity.amount}>
      {message}{" "}
      <PointIncrementEntity source={entity.source} entity={entity.entity} />
    </NotificationBody>
  );
};

export default PointIncrementNotification;
